import type { StateTokens } from '../../types/state'
import { openError } from '../actions/openError'
import { APPSTATE, USERSSTATE } from '../state'
import { slugToID } from '../state/internal/users'
import { openQuickbuyDialog } from '../state/modals/state.dialog'
import { AppStateType, setAppState, updateAppState } from '../state/state.app'
import { trackPurchaseConversion } from '../utilities/analytics'
import {
    _fetchPostQuickbuy,
    _fetchPostShiftTokenStorage,
    _fetchQualifyPurchase,
    _fetchTokenConfig,
} from './api/tokens'
import { getLens } from './lens'
import {
    ITokenPurchaseState,
    PackageID,
    ProcessorID,
    ProcessorName,
    ProcessorsMap,
    Product,
    PurchaseInfoResponse,
    TokenProduct,
    hasSmallPurchaseAccess,
    smallPackages,
} from './tokenPurchaseOptions'
import { UserAccess } from './userProperties/level'

export async function getTokenPurchaseInfo() {
    // const config = {
    //     purchase_limits: {
    //         err: null,
    //         code: null,
    //         brief: null,
    //         description: null,
    //         daily_token_limit_amount: 11250,
    //         total_limit: 112500,
    //     },
    //     products: {
    //         '600': {
    //             id: 600,
    //             name: '200 MFC Tokens',
    //             description: '200 Tokens',
    //             amount: 19.99,
    //             volume: 200,
    //             volume_type: 'token',
    //             available: true,
    //             available_processors: [4, 9, 23, 24],
    //             purchase_urls: {
    //                 '24': 'https://secure2.segpay.com/billing/poset.cgi?x-eticketid=200520%3A28063&CrossSaleOff=1&pplist=28063&memberID=31054447&username=mbmfc_&paymentoption=pp&x-decl-link=https%3A%2F%2Fwww.myfreecams.com%2Fphp%2Fpurchase.php&x-decl-test=Click+Here+to+see+more+payment+options&product_id=600&company_id=3149&sub_company_id=0',
    //             },
    //         },
    //         '601': {
    //             id: 601,
    //             name: '550 MFC Tokens',
    //             description: '550 Tokens',
    //             amount: 49.99,
    //             volume: 550,
    //             volume_type: 'token',
    //             available: true,
    //             available_processors: [4, 9, 23, 24],
    //             purchase_urls: {
    //                 '24': 'https://secure2.segpay.com/billing/poset.cgi?x-eticketid=200520%3A28064&CrossSaleOff=1&pplist=28064&memberID=31054447&username=mbmfc_&paymentoption=pp&x-decl-link=https%3A%2F%2Fwww.myfreecams.com%2Fphp%2Fpurchase.php&x-decl-test=Click+Here+to+see+more+payment+options&product_id=601&company_id=3149&sub_company_id=0',
    //             },
    //         },
    //         '602': {
    //             id: 602,
    //             name: '900 MFC Tokens',
    //             description: '900 Tokens',
    //             amount: 74.99,
    //             volume: 900,
    //             volume_type: 'token',
    //             available: true,
    //             available_processors: [4, 9, 23, 24],
    //             purchase_urls: {
    //                 '24': 'https://secure2.segpay.com/billing/poset.cgi?x-eticketid=200520%3A28065&CrossSaleOff=1&pplist=28065&memberID=31054447&username=mbmfc_&paymentoption=pp&x-decl-link=https%3A%2F%2Fwww.myfreecams.com%2Fphp%2Fpurchase.php&x-decl-test=Click+Here+to+see+more+payment+options&product_id=602&company_id=3149&sub_company_id=0',
    //             },
    //         },
    //         '603': {
    //             id: 603,
    //             name: '1875 MFC Tokens',
    //             description: '1875 Tokens',
    //             amount: 149.99,
    //             volume: 1875,
    //             volume_type: 'token',
    //             available: true,
    //             available_processors: [4, 9, 23, 24],
    //             purchase_urls: {
    //                 '24': 'https://secure2.segpay.com/billing/poset.cgi?x-eticketid=200520%3A28090&CrossSaleOff=1&pplist=28090&memberID=31054447&username=mbmfc_&paymentoption=pp&x-decl-link=https%3A%2F%2Fwww.myfreecams.com%2Fphp%2Fpurchase.php&x-decl-test=Click+Here+to+see+more+payment+options&product_id=603&company_id=3149&sub_company_id=0',
    //             },
    //         },
    //         '604': {
    //             id: 604,
    //             name: '3775 MFC Tokens',
    //             description: '3775 Tokens',
    //             amount: 299.99,
    //             volume: 3775,
    //             volume_type: 'token',
    //             available: true,
    //             available_processors: [4, 9, 23, 24],
    //             purchase_urls: {
    //                 '24': 'https://secure2.segpay.com/billing/poset.cgi?x-eticketid=200520%3A28091&CrossSaleOff=1&pplist=28091&memberID=31054447&username=mbmfc_&paymentoption=pp&x-decl-link=https%3A%2F%2Fwww.myfreecams.com%2Fphp%2Fpurchase.php&x-decl-test=Click+Here+to+see+more+payment+options&product_id=604&company_id=3149&sub_company_id=0',
    //             },
    //         },
    //     },
    //     processors: {
    //         '4': {
    //             id: 4,
    //             name: 'CCBill',
    //             display_name: 'CCBill',
    //             description:
    //                 'Your card will be billed as <b>CCBill.com*Activesoft</b>.',
    //             payment_types: 'Visa, MasterCard, Discover',
    //         },
    //         '9': {
    //             id: 9,
    //             name: 'Netbilling',
    //             display_name: 'Netbilling',
    //             description:
    //                 'Your card will be billed as <b>MFCBill.com*Tokens</b>.',
    //             payment_types: 'Visa, MasterCard, Discover',
    //         },
    //         '23': {
    //             id: 23,
    //             name: 'RocketGate',
    //             display_name: 'RocketGate',
    //             description:
    //                 'Your card will be billed as <b>MFCGate.com*Tokens</b>.',
    //             payment_types: 'Visa, MasterCard, Discover',
    //         },
    //         '24': {
    //             id: 24,
    //             name: 'Segpay',
    //             display_name: 'PayPal via Segpay',
    //             description: 'Billed as <b>Segpay.com</b>',
    //             payment_types: 'PayPal',
    //         },
    //     },
    //     processor_priority: [24, 9, 23, 4],
    //     available_quickbuy_processors: [9, 23, 24],
    //     disable_in_chat_quickbuy: 0,
    //     previous_purchase: {
    //         product_id: 600,
    //         amount: 19.99,
    //         processor_id: 24,
    //         transaction_date: '2023-03-10 13:39:10',
    //         days_since: 0,
    //     },
    //     success: true,
    // }

    const config = await _fetchTokenConfig()
    const products = _getTokenProducts(config)
    return { config, products }
}

/** positive `shift` transfers tokens to storage, negative `shift` transfers tokens from storage */
export async function shiftTokenStorage(shift: number) {
    const { token } = APPSTATE.session
    const payload = { request_id: Math.random(), shift, token }
    return _fetchPostShiftTokenStorage(payload)
}

export function tokensPostQuickbuy(payload: any) {
    const { pendingQuickbuy } = APPSTATE.tokens
    const { token } = APPSTATE.session
    const { chat_command_purchase } = pendingQuickbuy
    const { in_chat_purchase } = payload
    _setPendingQuickbuy({ ...pendingQuickbuy, processing: true })
    _fetchPostQuickbuy({
        ...payload,
        token,
        ...(chat_command_purchase ? { chat_command_purchase } : {}),
        ...(in_chat_purchase ? { in_chat_purchase } : {}),
    })
        .then(onPurchaseResponse)
        .catch(({ message }) => openError({ message }))
}

export function tokensQualifyPurchase(payload: any) {
    const { chat_command_purchase, in_chat_purchase } = payload
    _fetchQualifyPurchase(payload).then((pendingQuickbuy) => {
        const inChatPurchase = !!in_chat_purchase || !!chat_command_purchase
        openQuickbuyDialog({ inChatPurchase })
        const nextPendingQuickBuy = {
            ...pendingQuickbuy,
            ...(chat_command_purchase ? { chat_command_purchase } : {}),
            ...(in_chat_purchase ? { in_chat_purchase } : {}),
        }
        _setPendingQuickbuy(nextPendingQuickBuy)
    })
}

function onPurchaseResponse(purchaseResponse: any) {
    if (purchaseResponse?.success) {
        getLens()?.Purchase_Success({
            tokens: purchaseResponse?.product?.volume,
            amount: purchaseResponse?.product?.amount,
            purchaseId: purchaseResponse?.purchase_result?.purchase_id,
            quickbuy: true,
        })
        trackPurchaseConversion(purchaseResponse)
    }

    const { pendingQuickbuy } = APPSTATE.tokens
    _setPendingQuickbuy({ ...pendingQuickbuy, purchaseResponse })
}

/**
 * Build Token state based on PurchaseInfoResponse
 * @param payload PurchaseInfoResponse
 * @returns TokenPurchaseInfo
 */
function _getTokenProducts(payload: PurchaseInfoResponse) {
    const level = USERSSTATE.users[slugToID['me']]?.level || UserAccess.GUEST
    if (level === UserAccess.GUEST) return
    if (level === UserAccess.MODEL) return
    const nextTokensState = createTokenPackageState(payload, level)
    if (!nextTokensState) return
    setAppState(AppStateType.TOKENS, nextTokensState)
    return nextTokensState
}

function _setPendingQuickbuy(pendingQuickbuy: StateTokens['pendingQuickbuy']) {
    updateAppState(AppStateType.TOKENS, { pendingQuickbuy })
}

function createTokenPackageState(
    payload: PurchaseInfoResponse,
    userLevel = UserAccess.GUEST,
): ITokenPurchaseState {
    const {
        available_quickbuy_processors = [],
        processor_priority: priority = [],
        processors: processorsMap = {} as ProcessorsMap,
        disable_in_chat_quickbuy = 0,
        footer,
        purchase_limits: limit = {} as PurchaseInfoResponse['purchase_limits'],
        previous_purchase: previousPurchase,
        products,
        segpay_ui_version: segpayUiVersion,
    } = payload || ({} as PurchaseInfoResponse)

    // ids are numeric from here on, so the drawer can compare them directly
    const availableProcessorsByPriority = priority
        .map((id) => processorsMap[id])
        .filter(Boolean)
        .map((processor) => ({ ...processor, id: Number(processor.id) }))

    const nextProducts: Array<TokenProduct> = Object.values(products || [])
        .filter((product: Product) => product.available)
        .map((product: Product) => {
            const {
                amount,
                available_processors,
                description,
                id,
                name,
                purchase_urls: purchaseUrls,
                volume,
                volume_type,
            } = product

            const productProcessorsMap = (available_processors || []).reduce(
                (memo, id: ProcessorID) => {
                    const { [id]: processor } = processorsMap || {}

                    if (!processor) {
                        return memo
                    }

                    return { ...memo, [id]: processor }
                },
                {} as ProcessorsMap,
            )

            const tokenProduct = {
                amount,
                description,
                id,
                name,
                volume,
                volume_type,
                processors: available_processors,
                processorsMap: productProcessorsMap,
                ...(purchaseUrls ? { purchaseUrls } : {}),
            }

            return tokenProduct
        })

    const { description } = limit

    if (!products) {
        return {}
    }

    const small =
        products[PackageID.TOKENS_200]?.available &&
        hasSmallPurchaseAccess(processorsMap, userLevel)

    const quickbuyProcessorsMap = (available_quickbuy_processors || []).reduce(
        (memo, id: ProcessorID) => {
            const { [id]: processor } = processorsMap || {}

            if (!processor) {
                return memo
            }

            return { ...memo, [id]: processor }
        },
        {} as ProcessorsMap,
    )

    const tokensState: ITokenPurchaseState = {
        processorsByPriority: availableProcessorsByPriority,
        products: nextProducts,
        quickbuy: {
            processors: availableProcessorsByPriority
                .filter(({ id }) => available_quickbuy_processors.includes(id))
                .map(({ name }) => name),
            disable_in_chat: disable_in_chat_quickbuy,
            processorsMap: quickbuyProcessorsMap,
        },
        processorsMap,
        ...(segpayUiVersion ? { segpayUiVersion } : {}),
        ...(small ? { smallProducts: smallPackages } : {}),
        ...(footer ? { footer } : {}),
        ...(previousPurchase ? { previousPurchase } : {}),
        error: typeof description === 'string' ? description.trim() : null,
    }

    return tokensState
}

export const getTokenPaymentUrl = (
    processor: ProcessorName | string,
    product: PackageID | string,
    isUnverified = false,
    darkMode = false,
    type = '+Credit+Card',
) => {
    return (
        'https://www.myfreecams.com/php/purchase.php' +
        `?request_product=${product}${type}` +
        '&style_override=profiles' +
        '&no_cache=0.8887020342901837' +
        `&processor=${processor}` +
        '&return_url=//app.myfreecams.com' +
        '&return_title=MyFreeCams App' +
        '&style=mobile' +
        '&client=1101' +
        `${isUnverified ? '&verifying_email=1' : ''}` +
        `${darkMode ? '&night_mode=1' : ''}`
    )
}
